/* Fontis demo - scripted guided-selling assistant (no API calls, no keys) */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var chat = $("#chat"), log = $("#chat-log"), form = $("#chat-in"), input = $("#chat-text");
  if (!chat) return;
  var CAT = window.CATALOG || [], byId = {}; CAT.forEach(function (p) { byId[p.id] = p; });
  var eur = function (n) { return "€" + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ","); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  var S, queue = Promise.resolve(), started = false;
  function reset() { S = { seg: "", room: "", flue: "", m2: 0, fuel: "", budget: "", bmax: 0, recs: [], expect: "", guard: false, ctx: "" }; }
  reset();

  /* ------------- rendering */
  function scroll() { log.scrollTop = log.scrollHeight + 200; }
  function add(html, who, cls) {
    var d = document.createElement("div"); d.className = (who === "me" ? "msg me" : "msg bot") + (cls ? " " + cls : "");
    d.innerHTML = html; log.appendChild(d); scroll(); return d;
  }
  function block(el) { log.appendChild(el); scroll(); return el; }
  function say(msgs, after) {
    msgs = [].concat(msgs);
    msgs.forEach(function (m) {
      queue = queue.then(function () {
        return new Promise(function (res) {
          var t = document.createElement("div"); t.className = "typing"; t.innerHTML = "<i></i><i></i><i></i>"; block(t);
          var txt = typeof m === "string" ? m : (m.html || "");
          var delay = Math.min(1100, 420 + txt.replace(/<[^>]+>/g, "").length * 7);
          setTimeout(function () {
            t.remove();
            if (typeof m === "string") add(m);
            else if (m.el) block(m.el());
            else add(m.html, "bot", m.cls);
            res();
          }, delay);
        });
      });
    });
    if (after) queue = queue.then(function () { after(); });
    return queue;
  }
  function me(t) { add(esc(t), "me"); }
  function clearChips() { Array.prototype.slice.call(log.querySelectorAll(".qr")).forEach(function (q) { q.remove(); }); }
  function chips(opts, noHuman) {
    queue = queue.then(function () {
      clearChips();
      var q = document.createElement("div"); q.className = "qr";
      opts.forEach(function (o) {
        var b = document.createElement("button"); b.type = "button"; b.textContent = o.t; if (o.c) b.className = o.c;
        b.addEventListener("click", function () { clearChips(); if (!o.silent) me(o.t); o.f(); });
        q.appendChild(b);
      });
      if (!noHuman) {
        var h = document.createElement("button"); h.type = "button"; h.className = "human"; h.textContent = "Talk to a person";
        h.addEventListener("click", function () { clearChips(); me("I'd like to talk to a person"); handoff(); });
        q.appendChild(h);
      }
      block(q);
    });
  }
  function src(t) { return '<div class="srcline">&#128196; ' + t + "</div>"; }

  /* ------------- open / close */
  function open(q) {
    chat.classList.add("open"); chat.setAttribute("aria-hidden", "false");
    if (window.matchMedia("(max-width:699px)").matches) document.documentElement.style.overflow = "hidden";
    var n = $("#nudge"); if (n) n.classList.remove("on");
    if (!started) { started = true; start(q); } else if (q) context(q);
    setTimeout(function () { if (!window.matchMedia("(max-width:699px)").matches) input.focus(); }, 300);
  }
  function close() { chat.classList.remove("open"); chat.setAttribute("aria-hidden", "true"); document.documentElement.style.overflow = ""; }
  window.IFAssistant = { open: open, close: close };
  document.addEventListener("click", function (e) {
    var o = e.target.closest("[data-open-assistant]");
    if (o) {
      e.preventDefault();
      var l = o.closest(".drawer.open, .modal.open, .sheet.open"); if (l && window.IFclose) window.IFclose(l);
      open(o.getAttribute("data-q") || "");
      return;
    }
    if (e.target.closest("[data-chat-close]")) close();
    if (e.target.closest("[data-chat-reset]")) { log.innerHTML = ""; reset(); queue = Promise.resolve(); started = true; start(""); }
    if (e.target.closest("[data-human]")) { clearChips(); me("I'd like to talk to a person"); handoff(); }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && chat.classList.contains("open")) close(); });

  /* ------------- flow */
  function start(q) {
    var d = document.createElement("div"); d.className = "disclose";
    d.innerHTML = "You are talking to an <b>artificial intelligence</b>. On installation and safety it only answers with each manufacturer's documentation and hands you to a person when needed.";
    block(d);
    if (q && q !== "buscar") {
      say("Hello! I'm the Intelligent Fire AI assistant.");
      context(q); return;
    }
    say(["Hello! I'm the Intelligent Fire AI assistant.",
      q === "buscar" ? "Tell me what you're looking for: a model (FLA4, Neo, Astro...) or describe your space and I'll suggest 2-3 fireplaces in 60 seconds."
        : "I'll help you choose a fireplace in 60 seconds, using each manufacturer's technical data. And whenever you like, I'll put you through to a person on our team."]);
    chips([
      { t: "I'm a private customer", f: function () { S.seg = "Private customer"; askRoom(); } },
      { t: "I'm a professional (architect, interior designer, hotel)", f: pro },
      { t: "How much fuel does it use?", c: "faq", f: consumo },
      { t: "Can it be installed without ventilation?", c: "faq", f: guard }
    ]);
  }
  function context(q) {
    S.ctx = q;
    if (q === "seguridad") { me("Is a bioethanol fireplace safe?"); safety(); return; }
    if (q === "cabe") { S.seg = S.seg || "Private customer"; S.fuel = "bioetanol"; say("Let's check it against the Neo Fireplace 1000 data sheet. Roughly how many m² is your living room?"); m2chips(); return; }
    if (q === "proyecto") { S.seg = S.seg || "Private customer"; S.fuel = "bioetanol"; say("Let me help with your FLA4 project. To start: what is the floor area of the room?"); m2chips(); return; }
    if (q === "comparar") { say("Let me help you decide. First, your space:"); askRoom(); return; }
    if (q.indexOf("modelo:") === 0) { modelInfo(byId[q.slice(7)]); return; }
    askRoom();
  }
  function pro() {
    S.seg = "Professional";
    say("Great! We work with architecture and interior design studios every day. What do you need right now?");
    chips([
      { t: "Data sheets and CAD drawings", f: function () { say({ html: 'You\'ll find data sheets, 2D DWG files and official manuals from the manufacturers in the <a href="/en/pages/profesionales#biblioteca"><b>professional library</b></a>. We send BIM models on request within 24 h.' }); more(); } },
      { t: "Trade pricing", f: function () { say({ html: 'Studio prices are visible once your account is validated (24 working hours). <a href="/en/pages/profesionales#acceso"><b>Request professional access</b></a>.' }); more(); } },
      { t: "I have a project now", f: function () { S.room = "Professional project"; say("Perfect. I'll ask you 3 questions and suggest models for the project."); askFlue(); } }
    ]);
  }
  function askRoom() {
    S.expect = "room";
    say("Where do you want the fireplace?");
    chips([
      { t: "Living or dining room", f: function () { S.room = "Living room"; askFlue(); } },
      { t: "Bedroom", f: function () { S.room = "Bedroom"; askFlue(); } },
      { t: "Terrace or garden", f: function () { S.room = "Outdoor"; S.flue = "Not applicable"; S.fuel = "gas"; say("For outdoors we have gas models (natural gas or LPG). They are always installed by a certified installer."); askBudget(); } },
      { t: "Hotel, restaurant or office", f: function () { S.room = "Commercial"; S.seg = S.seg === "Professional" ? S.seg : "Commercial"; askFlue(); } }
    ]);
  }
  function askFlue() {
    S.expect = "flue";
    say("Do you have a chimney or flue in that room?");
    var next = function (v, t) { S.flue = v; say(t); askM2(); };
    chips([
      { t: "I don't have one", f: function () { next("No", "No problem: none of the fireplaces I'm going to suggest needs a flue."); } },
      { t: "Yes, I have one", f: function () { next("Yes", "Great, although you won't need it: these fireplaces don't use a flue, so you can put it wherever you like."); } },
      { t: "Not sure", f: function () { next("Not sure", "No problem: these fireplaces don't need a flue, so it doesn't limit your choice."); } }
    ]);
  }
  function m2chips() {
    S.expect = "m2";
    chips([
      { t: "Up to 20 m²", f: function () { setM2(18); } }, { t: "20-35 m²", f: function () { setM2(28); } },
      { t: "35-60 m²", f: function () { setM2(45); } }, { t: "Over 60 m²", f: function () { setM2(70); } }
    ]);
  }
  function askM2() { say("Roughly how many m² is the room? You can type the number."); m2chips(); }
  function setM2(v) {
    S.m2 = v; S.expect = "";
    var m3 = Math.round(v * 2.5);
    if (S.ctx === "cabe") {
      var ok = m3 >= 59;
      say({ html: "<p>With about " + v + " m² and a 2.5 m ceiling, your living room is about <b>" + m3 + " m³</b>.</p><p>" + (ok ? "<b>It meets</b> the minimum room volume for the Neo Fireplace 1000 (59 m³). You also need to renew 1 room volume of air per hour and a 230 V socket." : "The Neo Fireplace 1000 needs <b>59 m³</b>, so I wouldn't recommend it. The <b>Neo Fireplace 750</b> needs 41 m³" + (m3 >= 41 ? " and it fits." : ".") ) + "</p>" + src("Planika Neo 1000 Single-Sided data sheet, p. 2") });
      chips(ok ? [{ t: "Add the Neo 1000 to the basket", f: function () { close(); var b = document.querySelector("[data-add='neo-1000']"); if (b) b.click(); else location.href = "/en/products/neo-1000"; } }, { t: "Quote with installation", f: function () { askLead("WhatsApp"); } }]
        : [{ t: "See the Neo 750", f: function () { close(); location.href = "/en/products/neo-750"; } }, { t: "See other options", f: function () { S.ctx = ""; askFuel(); } }]);
      return;
    }
    if (S.ctx === "proyecto") {
      var ok2 = m3 >= 130;
      say({ html: "<p>With about " + v + " m² and a 2.5 m ceiling: <b>" + m3 + " m³</b>.</p><p>" + (ok2 ? "It suits the FLA4 1490, which needs <b>130 m³</b> and gives 13 kW." : "The FLA4 1490 needs <b>130 m³</b>. For your space I'd suggest the <b>FLA4 990</b> or a <b>Prime Fire 2.0</b>, or more height if it's a double-height room.") + "</p>" + src("Planika FLA4 1490 data sheet, p. 2") });
      chips([{ t: "Book a design consultation", f: function () { close(); location.href = "/en/products/fla4-1490#consulta"; } }, { t: "Quote by WhatsApp", f: function () { askLead("WhatsApp"); } }]);
      return;
    }
    say("About " + m3 + " m³ with a 2.5 m ceiling. Noted: every bioethanol fireplace needs a minimum room volume.");
    askFuel();
  }
  function askFuel() {
    S.expect = "fuel";
    say("What kind of fire do you have in mind?");
    chips([
      { t: "Real flame (bioethanol)", f: function () { S.fuel = "bioetanol"; askBudget(); } },
      { t: "Electric: plug in and go", f: function () { S.fuel = "electrica"; askBudget(); } },
      { t: "Water vapour: no heat", f: function () { S.fuel = "vapor"; askBudget(); } },
      { t: "Advise me", f: function () { S.fuel = "any"; say("I'll suggest what fits best for your space and budget."); askBudget(); } }
    ]);
  }
  function askBudget() {
    S.expect = "budget";
    say("Last question: what's your budget, including installation? You can spread it over up to 36 months.");
    var b = function (t, max) { return { t: t, f: function () { S.budget = t; S.bmax = max; recommend(); } }; };
    chips([b("Up to €2,500", 2500), b("2.500-5.000 €", 5000), b("5.000-10.000 €", 10000), b("Over €10,000", 99999), b("I'd rather not say", 0)]);
  }
  function recommend() {
    S.expect = "";
    var m3 = S.m2 ? Math.round(S.m2 * 2.5) : 0;
    var pool = CAT.filter(function (p) {
      if (S.room === "Outdoor") return p.inst === "exterior";
      if (p.inst === "exterior") return false;
      if (S.fuel && S.fuel !== "any" && p.fuel !== S.fuel) return false;
      if (m3 && p.m3 && m3 < p.m3) return false;
      return true;
    });
    var within = pool.filter(function (p) { return !S.bmax || p.price <= S.bmax * 1.05; });
    if (!within.length) within = pool.slice().sort(function (a, b) { return a.price - b.price; });
    var target = S.bmax ? Math.min(S.bmax, 30000) : 5000;
    within.sort(function (a, b) {
      var sa = Math.abs(target * 0.85 - a.price) - (a.m3 && m3 ? 400 : 0) - (a.url && a.url[0] === "/" ? 600 : 0);
      var sb = Math.abs(target * 0.85 - b.price) - (b.m3 && m3 ? 400 : 0) - (b.url && b.url[0] === "/" ? 600 : 0);
      return sa - sb;
    });
    var recs = within.slice(0, 3); S.recs = recs.map(function (p) { return p.name; });
    say(recs.length ? "Based on what you've told me, here are my suggestions:" : "I don't have a model that ticks every box. I'll hand you to a person to find alternatives.");
    if (!recs.length) { handoff(); return; }
    say({ el: function () {
      var w = document.createElement("div"); w.className = "recs";
      recs.forEach(function (p, i) {
        var why = [];
        if (p.m3 && m3) why.push("Needs " + p.m3 + " m³ and your room is about " + m3 + " m³");
        if (p.inst === "sin-obra") why.push("No building work: put it in place and light it");
        if (p.inst === "encastrable" && p.fuel !== "electrica") why.push("Built into a wall or unit, no flue needed");
        if (p.fuel === "electrica") why.push("Only needs a socket");
        if (p.fuel === "vapor") why.push("Cool water vapour: safe with children");
        if (p.inst === "exterior") why.push("For outdoors, gas");
        if (p.app) why.push("App and remote control");
        if (S.bmax && p.price <= S.bmax) why.push("Within your budget: " + p.mo + " €/month");
        if (p.mode === "project") why.push("Bespoke project with a technical visit");
        var a = document.createElement("a"); a.className = "rec"; a.href = p.url;
        if (p.url[0] === "#") a.addEventListener("click", function (e) { e.preventDefault(); close(); if (window.IFquick) window.IFquick(p.id); });
        a.innerHTML = '<img src="' + p.img + '" alt=""><div>' + (i === 0 ? '<span class="top">Best match</span>' : "") + "<b>" + p.name + '</b><div class="pr">' + (p.frm ? "From " : "") + eur(p.price) + " <small>or " + p.mo + " €/month</small></div><ul>" + why.slice(0, 3).map(function (x) { return "<li>" + x + "</li>"; }).join("") + "</ul></div>";
        w.appendChild(a);
      });
      return w;
    } });
    say("Shall I send you this comparison with the installation price on WhatsApp? Someone from our technical team reviews it before sending.");
    chips([
      { t: "Yes, on WhatsApp", f: function () { askLead("WhatsApp"); } },
      { t: "Email is better", f: function () { askLead("Email"); } },
      { t: "Book a video consultation", f: function () { askLead("Video call"); } }
    ]);
  }
  function askLead(channel) {
    say(channel === "Email" ? "Perfect. Leave me your name and email:" : "Perfect. Leave me your name and phone number and we'll get back to you within 1 hour (Mon-Fri 9:00-19:00):");
    say({ el: function () {
      var f = document.createElement("form"); f.className = "chat-form";
      f.innerHTML = '<input class="input" name="n" placeholder="Name" required autocomplete="given-name">' +
        (channel === "Email" ? '<input class="input" name="c" type="email" placeholder="Email" required autocomplete="email">' : '<input class="input" name="c" type="tel" placeholder="Phone (WhatsApp)" required autocomplete="tel">') +
        '<input class="input" name="cp" placeholder="Postcode (to assign an installer)" inputmode="numeric">' +
        '<label class="check"><input type="checkbox" required> I accept the privacy policy and agree to be contacted by ' + channel + ".</label>" +
        '<button class="btn btn-ember btn-block btn-sm">Send</button>';
      f.addEventListener("submit", function (e) {
        e.preventDefault(); if (!f.checkValidity()) { f.reportValidity(); return; }
        var n = f.n.value.trim(); f.remove(); me(n + " · " + f.c.value);
        done(channel, n, f.cp.value, f.c.value.trim());
      });
      return f;
    } });
  }
  function done(channel, name, cp, contact) {
    say("Done, " + esc(name) + "! " + (channel === "Video call" ? "We will message you to set the time of the video consultation and send you the link." : "Someone from our technical team will contact you by " + channel + " within 1 hour (Mon-Fri 9:00-19:00). Outside those hours, first thing next morning."));
    var rows = [["Segment", S.seg || "Private customer"], ["Space", S.room || "-"], ["Flue", S.flue || "-"], ["Floor area", S.m2 ? S.m2 + " m²" : "-"],
      ["Fuel", { bioetanol: "Bioethanol", electrica: "Electric", vapor: "Water vapour", gas: "Gas", any: "No preference" }[S.fuel] || "-"], ["Budget", S.budget || "-"],
      ["Recommended", S.recs.join(", ") || "-"]];
    if (S.guard) rows.push(["Alert", "Safety question passed to a technician"]);
    var conv = AIH.slice(-6).map(function (m) { return (m.role === "user" ? "Cliente: " : "IA: ") + m.content.replace(/\[Contexto de la web:[^\]]*\]\s*/, "").replace(/\[\[[^\]]*\]\]/g, "").slice(0, 400); }).join(" || ");
    if (window.IFsendLead) window.IFsendLead({ oferta: "asistente-ia", nombre: name, telefono: channel === "Email" ? "" : contact, email: channel === "Email" ? contact : "",
      provincia: cp || "", canal: channel, espacio: S.room || "", presupuesto: S.budget || "", calidad: S.bmax && S.bmax < 3000 ? "presupuesto_bajo" : "cualificado",
      mensaje: rows.filter(function (r) { return r[1] !== "-"; }).map(function (r) { return r[0] + ": " + r[1]; }).join(" | ") + (conv ? " || Conversación: " + conv : "") });
    more();
  }
  function waSummary(name) {
    var t = "Hello, I'm " + (name || "") + ". I'm coming from the website assistant.\n" +
      (S.room ? "Space: " + S.room + (S.m2 ? " (" + S.m2 + " m²)" : "") + "\n" : "") +
      (S.budget ? "Budget: " + S.budget + "\n" : "") + (S.recs.length ? "I'm interested in: " + S.recs.join(", ") + "\n" : "") + "Could you send me a price including installation?";
    if (window.IFwa) window.IFwa(t);
  }
  function handoff() {
    say("Of course. Someone from our technical team is available Mon-Fri 9:00-19:00. How would you prefer?");
    chips([
      { t: "WhatsApp now", f: function () { say("I'm passing you to WhatsApp with a summary of this conversation, so you don't have to repeat anything."); queue = queue.then(function () { waSummary(""); }); more(); } },
      { t: "Call me", f: function () { askLead("Phone"); } },
      { t: "Video call", f: function () { askLead("Video call"); } }
    ], true);
  }
  function more() {
    chips([{ t: "Choose a fireplace", f: function () { S.ctx = ""; askRoom(); } }, { t: "I have another question", f: function () { say("Of course, go ahead."); } }]);
  }

  /* ------------- grounded answers */
  function guard() {
    S.guard = true;
    say({ cls: "guard", html: "<p>I can only answer with what the manufacturer's documentation says:</p><p>• Bioethanol fireplaces need <b>1 room volume of fresh air per hour</b>.<br>• Each model needs a <b>minimum room volume</b>: 41 m³ for the Neo 500 and 750, 59 m³ for the Neo 1000 and 130 m³ for the FLA4 1490.</p><p><b>I can't confirm it can be installed in a room without ventilation.</b> A technician has to assess that with your measurements.</p>" + src("Planika Neo 1000 and FLA4 1490 data sheets (2025-2026)") });
    say("I'll put you through to someone from our technical team. If there is no ventilation, an electric or water vapour fireplace may be the alternative.");
    chips([
      { t: "Talk to a technician", f: handoff },
      { t: "See electric fireplaces", f: function () { location.href = "/en/collections/chimeneas-electricas"; } },
      { t: "See water vapour models", f: function () { location.href = "/en/collections/vapor-de-agua"; } }
    ], true);
  }
  function consumo() {
    say({ html: "<p>According to the manufacturer, a <b>1-metre burner uses roughly 1 litre of bioethanol per hour</b>. With bioethanol at around €4.50/L, that is about <b>€4.50 per hour</b> of fire.</p><p>Automatic BEV burners use up to 20% less fuel than manual ones. An electric fireplace uses what its heater draws: 1.5 or 3 kW.</p>" + src("Manufacturer data sheet: Fanola bioethanol (Planika)") });
    more();
  }
  function safety() {
    say({ html: "<p>Automatic models with a BEV burner use <b>BEV technology</b>: they heat the bioethanol in an insulated tank and burn only its vapours. The flame never touches the liquid.</p><p>They have temperature, fuel level and spill sensors, a child lock, and are refilled with a pump that stops by itself. No smoke, no smell and no ash.</p>" + src("Manufacturer's technical documentation (Planika FLA4 and Neo)") });
    more();
  }
  function modelInfo(p) {
    if (!p) { askRoom(); return; }
    say({ html: "<p><b>" + p.name + "</b> (" + p.brand + " " + p.fam + "). " + esc(p.note) + "</p><p>" + p.chips.join(" · ") + ". " + (p.frm ? "From " : "") + eur(p.price) + " o " + p.mo + " €/month.</p>" });
    chips([{ t: "Will it fit my space?", f: function () { S.fuel = p.fuel; askM2(); } }, { t: "See alternatives", f: function () { S.fuel = p.fuel; askRoom(); } }]);
  }

  /* ------------- free text */
  var MODELS = [["fla4", "fla4-1490"], ["neo", "neo-1000"], ["prime", "prime-790"], ["vertis", "vertis"], ["arcticon", "arcticon"], ["astro", "astro-1500"], ["aura", "aura"], ["misty", "misty"], ["bubble", "bubble"], ["forma", "forma-1500"], ["faro", "faro"], ["galio", "galio-star"]];
  /* ------------- IA (Claude przez worker fontis-ai, klucz Pedra) */
  var AI_URL = window.FONTIS_AI_URL || "https://fontis-ai.adsfly-aios.workers.dev/chat";
  var AIH = [], aiBusy = false;
  function mdLite(x) { return esc(x).replace(/\*\*([^*]+)\*\*/g, "<b>$1</b>").replace(/\n{2,}/g, "<br><br>").replace(/\n/g, "<br>"); }
  function ctxLine() {
    var b = ["página: " + document.title.split("|")[0].trim()];
    if (S.seg) b.push("perfil: " + S.seg); if (S.room) b.push("espacio: " + S.room); if (S.m2) b.push("superficie: " + S.m2 + " m²");
    if (S.flue) b.push("salida de humos: " + S.flue); if (S.fuel) b.push("tipo: " + S.fuel); if (S.budget) b.push("presupuesto: " + S.budget);
    if (S.recs.length) b.push("ya le propusimos: " + S.recs.join(", "));
    return "[Contexto de la web: " + b.join("; ") + "]\n\n";
  }
  function recCards(ids) {
    var w = document.createElement("div"); w.className = "recs";
    ids.forEach(function (id) {
      var p = byId[id]; if (!p) return;
      var a = document.createElement("a"); a.className = "rec"; a.href = p.url;
      if (p.url[0] === "#") a.addEventListener("click", function (e) { e.preventDefault(); close(); if (window.IFquick) window.IFquick(p.id); });
      a.innerHTML = '<img src="' + p.img + '" alt=""><div><b>' + p.name + '</b><div class="pr">' + (p.frm ? "From " : "") + eur(p.price) + "</div><ul><li>" + esc(p.note || "") + "</li></ul></div>";
      w.appendChild(a);
    });
    return w.children.length ? w : null;
  }
  function ai(t) {
    if (aiBusy) return;
    aiBusy = true; input.disabled = true;
    AIH.push({ role: "user", content: ctxLine() + t });
    queue = queue.then(function () { return new Promise(function (res) {
      var typing = document.createElement("div"); typing.className = "typing"; typing.innerHTML = "<i></i><i></i><i></i>"; block(typing);
      var bubble = null, full = "", stop = "";
      function show() {
        var vis = full.split("[[")[0].replace(/\s+$/, ""); if (!vis) return;
        if (!bubble) { typing.remove(); bubble = add("", "bot"); }
        bubble.innerHTML = mdLite(vis); scroll();
      }
      function finish() {
        typing.remove(); aiBusy = false; input.disabled = false;
        if (!full.trim()) { AIH.pop(); legacy(t); res(); return; }
        AIH.push({ role: "assistant", content: full });
        var m = full.match(/\[\[\s*productos?\s*:\s*([^\]]+)\]\]/i);
        if (m) {
          var ids = m[1].split(/[,\s]+/).filter(function (x) { return byId[x]; }).slice(0, 3), el = recCards(ids);
          if (el) { block(el); S.recs = ids.map(function (i) { return byId[i].name; }); }
        }
        if (stop === "error" || stop === "refusal") handoff();
        else if (/\[\[\s*contacto\s*\]\]/i.test(full)) chips([
          { t: "Message me on WhatsApp", f: function () { askLead("WhatsApp"); } },
          { t: "Call me", f: function () { askLead("Phone"); } },
          { t: "By email", f: function () { askLead("Email"); } }], true);
        res();
      }
      fetch(AI_URL, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ messages: AIH }) }).then(function (r) {
        if (!r.ok || !r.body) throw new Error("ai " + r.status);
        var reader = r.body.getReader(), dec = new TextDecoder(), buf = "";
        function pump() {
          return reader.read().then(function (x) {
            if (x.done) { finish(); return; }
            buf += dec.decode(x.value, { stream: true });
            var parts = buf.split("\n\n"); buf = parts.pop();
            parts.forEach(function (p) {
              if (p.indexOf("data:") !== 0) return;
              try { var d = JSON.parse(p.slice(5)); if (d.t) { full += d.t; show(); } if (d.done) stop = d.stop || ""; } catch (e) {}
            });
            return pump();
          });
        }
        return pump();
      }).catch(function () { finish(); });
    }); });
  }
  function handle(t) {
    var s = t.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
    clearChips();
    if (S.expect === "m2") { var mm = s.match(/(\d+[.,]?\d*)/); if (mm) return setM2(Math.round(parseFloat(mm[1].replace(",", ".")))); }
    if (S.expect === "budget") { var bb = s.match(/(\d[\d.]*)/); if (bb) { var vv = parseInt(bb[1].replace(/\./g, ""), 10); if (vv < 100) vv *= 1000; S.budget = "~" + eur(vv); S.bmax = vv; return recommend(); } }
    return ai(t);
  }
  function legacy(t) {
    var s = t.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
    if (/(sin ventil|ventilaci|sin ventana|cerrad|habitacion pequen|dormitorio pequen|bano|caravana|barco|sin aire|ventilat|no window|windowless|closed room|small room|small bedroom|bathroom|no air|airtight)/.test(s)) return guard();
    if (/(persona|humano|asesor|agente|llamad|llamar|whats|telefono|hablar con|person|human|advisor|adviser|agent|call me|phone|talk to|speak to)/.test(s)) return handoff();
    if (S.expect === "m2") { var m = s.match(/(\d+[.,]?\d*)/); if (m) return setM2(Math.round(parseFloat(m[1].replace(",", ".")))); }
    if (/\bgas\b|butano|propano|glp|butane|propane|lpg/.test(s)) { say("The gas fireplaces we sell are for outdoor use and are always installed by a certified gas installer (RD 919/2006). So I don't give you incomplete information, I'll hand you to someone from our technical team."); return handoff(); }
    if (/(consum|gasta|gasto|litro|coste de uso|cuesta usar|por hora|litre|liter|running cost|per hour|how much fuel|use per)/.test(s)) return consumo();
    if (/(segur|peligr|nino|humo|olor|toxic|co2|monoxido|incendi|safe|danger|child|kid|smoke|smell|odour|odor|carbon|fire risk)/.test(s)) return safety();
    if (/(balear|mallorca|ibiza|menorca|formentera|canari|tenerife|palma)/.test(s)) { say("We install in mainland Spain and the Balearics, on a fixed date, and deliver bioethanol to your door on the islands too. Canary Islands: ask us (invoiced as an export without Spanish VAT, IGIC paid at destination)."); return more(); }
    if (/garant|warrant/.test(s)) { say("All products have a 3-year legal warranty. The FLA4 range adds up to 5 years of manufacturer's warranty if you register the product within 30 days."); return more(); }
    if (/(plazo|financ|cuota|al mes|mensual|pagar|instal?ment|monthly|per month|pay over)/.test(s)) { say("We are setting up payment in instalments. If you are interested, someone from the team will confirm the available options."); return handoff(); }
    for (var i = 0; i < MODELS.length; i++) if (s.indexOf(MODELS[i][0]) > -1) return modelInfo(byId[MODELS[i][1]]);
    if (S.expect === "fuel") {
      if (/(bio|etanol|ethanol|real|llama|flame)/.test(s)) { S.fuel = "bioetanol"; return askBudget(); }
      if (/(electr|enchuf|plug)/.test(s)) { S.fuel = "electrica"; return askBudget(); }
      if (/(vapor|agua|water|steam|mist)/.test(s)) { S.fuel = "vapor"; return askBudget(); }
    }
    if (S.expect === "budget") { var b = s.match(/(\d[\d.]*)/); if (b) { var v = parseInt(b[1].replace(/\./g, ""), 10); if (v < 100) v *= 1000; S.budget = "~" + eur(v); S.bmax = v; return recommend(); } }
    if (/(precio|cuanto cuesta|cuanto vale|barat|caro|price|cost|how much|cheap|expensive)/.test(s)) { say("We go from €389 (Faro outdoor heater) to bespoke projects from €12,299 with installation. Most living rooms are between €2,300 and €5,000. Shall I help you narrow it down?"); return askRoom(); }
    if (/(electr)/.test(s)) { S.fuel = "electrica"; say("Astro electric fireplaces only need a socket: 3D LED flame and 1,5 or 3 kW heating."); return askBudget(); }
    if (/(salon|comedor|piso|casa|living|lounge|dining|flat|apartment|house|home)/.test(s) && !S.room) { S.room = "Living room"; return askFlue(); }
    if (/(hola|buenas|hey|hello|\bhi\b|good (morning|afternoon|evening))/.test(s)) { say("Hello! Tell me about your space or choose an option."); return askRoom(); }
    say("Good question. So I don't give you an inaccurate answer, I'd rather someone from our technical team confirms it.");
    handoff();
  }
  form.addEventListener("submit", function (e) {
    e.preventDefault(); var t = input.value.trim(); if (!t) return; input.value = ""; me(t); handle(t);
  });
})();
